import { render } from "./FirstBicom.vue?vue&type=template&id=41dbe36e&scoped=true"
import script from "./FirstBicom.vue?vue&type=script&lang=js"
export * from "./FirstBicom.vue?vue&type=script&lang=js"

import "@/assets/styles/firstbicom.scss?vue&type=style&index=0&id=41dbe36e&scoped=true&lang=scss"

import exportComponent from "/home/djokic/Projects/mariv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41dbe36e"]])

export default __exports__